import React from 'react';
import Typography from "@material-ui/core/Typography";
import {withStyles} from "@material-ui/core";

const styles = (theme) => ({
    root: {
        color: theme.palette.common.white,
        textAlign: 'center',
        marginTop: theme.spacing(3)
    }
});

const AppFooter = ({classes, ...props}) => {
    return (
        <div className={classes.root}>
            <Typography variant='body1' color='inherit'>
                Copyright © {new Date().getFullYear()} - Airgloss S.r.l. - All rights reserved.
            </Typography>
        </div>
    );
};

AppFooter.propTypes = {};

export default withStyles(styles)(AppFooter);
